<template>
	<div class="user-management">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Log Activities</h1>
				<div class="page-header-right text-right ml-a">
					<!-- Date Filter -->
					<daterangepicker :presets="filterDatePresets" :start="since" :end="until" @selected="setFilterDate"
						ref="datePicker">
					</daterangepicker>
				</div>
			</div>
			<div class="page-content">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-6">

						</div>
						<div class="col-sm-6">
							<div class="table-filters d-flex align-items-center justify-content-end ml-a">
								<!-- Clear Filter -->
								<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
									{{ $t('Clear Filter') }}
								</button>
								<!-- Filter -->
								<button type="button" class="filter-toggle btn btn-light btn-sm btn-icon"
									@click="isShowFilter = true">
									<i class="material-icons mr-1">filter_list</i>Filter Activity Log
								</button>
								<!-- Search Keyword -->
								<input type="text" class="input form-control form-control-sm users-search-box"
									placeholder="Category / Status / Type ..." autocomplete="off" @input="onKeywordChange"
									v-model="keyword" />
							</div>
						</div>
					</div>
				</div>
				<!-- Log Activity List -->
				<div class="users-list table-responsive">
					<table class="users-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th width="10%" class="text-left" :class="sortClass('causer.name')"
								@click="changeSorting('causer.name')" >
									Admin
								</th>
								<th width="5%" class="th-sort text-left" :class="sortClass('causer.role')"
									@click="changeSorting('causer.role')">
									Role
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('url')"
									@click="changeSorting('url')">
									Url
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('subject_type')"
								@click="changeSorting('subject_type')">
									Category
								</th>
								<th width="5%" class="th-sort text-left" :class="sortClass('date')"
									@click="changeSorting('date')">
									Date
								</th>
								<th width="5%" class="th-sort text-left" :class="sortClass('total')"
									@click="changeSorting('total')">
									Event
								</th>
								<th width="5%" class="th-sort text-left" :class="sortClass('event')"
									@click="changeSorting('event')">
									Type
								</th>
								<th width="5%" class="text-left">
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item) in items" :key="item._id">
								<td>
									<div class="row">
										<div class="col-12">
											{{ item.causer.name }}
										</div>
										<div class="col-12">
											{{ item.causer.email }}
										</div>
									</div>
								</td>
								<td>
									{{ item.causer.role }}
								</td>
								<td class="overflow-auto">
									{{ item.url }}
								</td>
								<td class="">
									{{ item.subject_type }}
								</td>
								<td>
									{{ formatDateWithTime(item.updated_at) }}
								</td>
								<td>
									{{ item.total }}
								</td>
								<td>
									<div class="btn btn-sm text-white user-select-none" :class="{
										'btn-primary': item.event === 'created',
										'btn-warning': item.event === 'updated',
										'btn-danger': item.event === 'deleted',
										'btn-success': item.event === 'exported',
									}">
										{{ item.event }}
									</div>
								</td>
								<td>
									<button @click="showDetail(item)" class="btn btn-sm btn-outline-primary">
										Detail
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Log Activity yet.</span>
						<span v-else>No Log Activity was found</span>
					</div>
				</div>
			</div>
		</div>
		<!-- MODAL DETAIL -->
		<modal :size="'large'" v-if="isShowDetail" @close="isShowDetail = false">
			<div slot="header">
				<h3>Detail Log Activity</h3>
			</div>
			<div slot="body">
				<span class="text-bold p-1 d-block">
					{{ causerName(activity) }}
				</span>
				<span class="p-1">
					{{ causerEmail(activity) }}
				</span>
				<table class="mt-4">
					<tr>
						<td>URL</td>
						<td class="px-2">:</td>
						<td class="word-break">{{ activity.url }}</td>
					</tr>
					<tr>
						<td>Category</td>
						<td class="px-2">:</td>
						<td>{{ activity.subject_type }}</td>
					</tr>
					<tr v-if="activity.event === 'exported'">
						<td>Since</td>
						<td class="px-2">:</td>
						<td v-if="exportedDate && exportedDate.since">{{ formatDateWithTime(exportedDate.since, 'DD-MM-YYYY') }}</td>
						<td v-else>-</td>
					</tr>
					<tr v-if="activity.event === 'exported'">
						<td>Until</td>
						<td class="px-2">:</td>
						<td v-if="exportedDate.until && exportedDate">{{ formatDateWithTime(exportedDate.until, 'DD-MM-YYYY') }}</td>
						<td v-else>-</td>
					</tr>
				</table>
				<div>
					<!-- Section: Timeline -->
					<section class="py-5">
						<ul class="timeline-with-icons">
							<li class="timeline-item mb-5" v-for="item in activityDetail.data" :key="item._id">
								<span class="timeline-icon">
									<i class="fas fa-edit text-primary fa-sm fa-fw"></i>
								</span>
								<div class="log-activity-item">
									<p class="text-muted mb-2 fw-bold">{{ formatDateWithTime(item.created_at) }}</p>
									<div class="log-activity-description text-muted">
										Deskripsi: {{ showDescription(item, activity) }}
									</div>
									<div class="log-activity-description text-muted">
										<span class="text-bold" v-if="item.identifiers !== null && item.identifiers.id !== null ">
											Identifiers : <br>{{ jsonPretty(item.identifiers) }}
										</span>

										<div class="row"></div>
										<div class="container body-log-modal mt-3" v-if="item.properties">
											<!-- <div class="row" v-for="(changes, index) in selectedProduct.change_logs" :key="index"> -->
											<div class="row">
												<div class="col-md-6 changes-style-current">
													<div>
														<h6 class="text-bold">Old Value</h6>
														<pre>{{ jsonPretty(item.properties.old) }}</pre>
													</div>
												</div>

												<div class="col-md-6 changes-style">
													<div>
														<h6 class="text-bold">New Value</h6>
														<pre>{{ jsonPretty(item.properties.properties) }}</pre>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</section>
					<!-- Section: Timeline -->
				</div>
			</div>
		</modal>
		<!-- MODAL FILTER -->
		<!-- Table Filter -->
		<modal class="table-filter-modal" size="medium" @close="isShowFilter = false" v-if="isShowFilter">
			<div slot="header">
				<h3><i class="material-icons">filter_list</i>Filter Products</h3>
			</div>
			<div slot="body">
				<!-- status -->
				<div class="form-group">
					<label for="">
						<b class="">
							Type
						</b>
					</label>
					<select class="form-control" v-model="event">
						<option value="">All</option>
						<option value="created">Created</option>
						<option value="updated">Updated</option>
						<option value="deleted">Deleted</option>
						<option value="exported">Exported</option>
					</select>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowFilter = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-primary" @click="applyFilter">Apply</button>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import Daterangepicker from '@/components/Daterangepicker.vue';
import {
	duplicateVar,
	getDateRange,
	// getAxiosErrorMessage,
	formatMoney,
	jsonPretty,
	// downloadFile,
	formatDate,
} from '@/lib/helper';
// import { defaultProductImageOstock } from '@/lib/statics';
import activityLogApi from '@/api/activity-log';
import Modal from '@/components/Modal.vue';

const utcPlugin = require('dayjs/plugin/utc');
const timezonePlugin = require('dayjs/plugin/timezone');


// Extend dayjs with plugins
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

export default {
	name: 'AdminActivityLog',
	components: {
		Daterangepicker,
		Modal,
	},
	data() {
		return {
			keyword: '',
			since: '',
			until: '',
			limit: '',
			sort_by: 'updated_at',
			sort: '-1',
			selectAll: '',
			event: '',
			isFetching: false,
			items: [],
			isShowDetail: false,
			isShowFilter: false,
			activityDetail: {},
			activity: {},
			selectedItems: [],
		};
	},
	methods: {
		formatMoney,
		jsonPretty,
		resetItems() {
			this.items = [];
			this.page = 1;
		},
		formatDate,
		causerName(activity) {
			return activity?.causer?.name ?? '';
		},
		causerEmail(activity) {
			return activity?.causer?.email ?? '';
		},
		showDescription(item, activity) {
			if (item.event === 'updated') {
				return `${activity.causer.name} Telah Mengubah Data Pada ${item.subject_type}`;
			}
			if (item.event === 'created') {
				return `${activity.causer.name} Telah Membuat Data Pada ${item.subject_type}`;
			}
			if (item.event === 'deleted') {
				return `${activity.causer.name} Telah Menghapus Data ${item.subject_type}`;
			}
			if (item.event === 'exported') {
				return `${activity.causer.name} Telah Mengexport Data ${item.subject_type}`;
			}
			return '';
		},
		showDetail(item) {
			this.isShowDetail = true;
			const causerId = item.causer._id.$oid;

			const params = {
				log_activities_id: item._id,
			};

			const callback = (response) => {
				this.activity = item;
				this.activityDetail = response.data;
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			activityLogApi.getDetail(causerId, params, callback, errorCallback);
		},
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: this.since,
				until: this.until,
			};

			if (this.event !== '') {
				params.event = this.event;
			}

			if (this.keyword !== '') {
				params.keyword = this.keyword;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				const items = response.data.data;
				this.isShowFilter = false;
				if (items.length > 0) {
					this.page++;
					this.items = this.items.concat(items);
				} else {
					this.isAll = true;
				}
				console.log(this.items);
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			activityLogApi.getList(params, callback, errorCallback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		formatDateWithTime(date, format = 'DD-MM-YYYY HH:mm:ss') {
			return dayjs.utc(date).tz(this.user?.timezone).format(format);
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const dateFormat = 'YYYY-MM-DD';
			const since = dayjs(filterDate.start).format(dateFormat);
			const until = dayjs(filterDate.end).format(dateFormat);
			this.since = since;
			this.until = until;
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchItems(true);
		},
		initFilterDate() {
			const dateRange = getDateRange();
			const hasSinceQuery = this.sinceQuery && this.sinceQuery !== '';
			const hasUntilQuery = this.untilQuery && this.untilQuery !== '';
			const sinceDate = hasSinceQuery
				? dayjs(this.sinceQuery)
				: dayjs(dateRange.start);
			const untilDate = hasUntilQuery
				? dayjs(this.untilQuery)
				: dayjs(dateRange.end);
			const filterDate = {
				start: sinceDate,
				end: untilDate,
			};
			this.filterDate = filterDate;

			const dateFormat = 'YYYY-MM-DD';
			this.since = sinceDate.format(dateFormat);
			this.until = untilDate.format(dateFormat);
		},
		applyFilter() {
			this.fetchItems(true);
		},
		resetFilter() {
			this.event = '';
			this.keyword = '';
		},
		clearFilter() {
			this.$router.replace({ query: null });
			this.resetFilter();
			this.applyFilter();
		},
		onKeywordChange() {
			this.ooDelay(() => {
				if (this.isAdmin) {
					this.fetchItems();
				} else if (this.isSupport) {
					if (this.keyword.trim() === '') {
						this.resetItems();
					} else {
						this.fetchItems();
					}
				}
			}, 1000);
		},

		getQueryParam(param) {
			const queryString = this.activity.url;
			const params = queryString.split('&');

			if (params.length > 0) {
				for (let i = 0; i < params.length; i++) {
					const pair = params[i].split('=');
					if (decodeURIComponent(pair[0]) === param) {
						return decodeURIComponent(pair[1]);
					}
				}
			}
			return null;
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
			user: 'user',
			filterDatePresets: 'filterDatePresets',
		}),
		sinceQuery() {
			const since = this.$route.query.since;
			return since;
		},
		untilQuery() {
			const until = this.$route.query.until;
			return until;
		},
		isFilterOn() {
			return this.keyword !== ''
				|| this.event !== '';
		},
		exportedDate() {
			const since = this.getQueryParam('since');
			const until = this.getQueryParam('until');

			return {
				since,
				until,
			};
		},
	},
	created() {
		this.initFilterDate();
		this.fetchItems();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
.icon-style {
	font-size: 20px;
	cursor: pointer;
}

.preview-img {
	max-width: 100px;
	max-height: 100px;
}

.multiselect-invalid {
	.multiselect__tags {
		border-color: #ed1c24;
	}
}

.timeline-with-icons {
	border-left: 1px solid $primary_color;
	position: relative;
	list-style: none;
}

.timeline-with-icons .timeline-item {
	position: relative;
}

.timeline-with-icons .timeline-item:after {
	position: absolute;
	display: block;
	top: 0;
}

.timeline-with-icons .timeline-icon {
	position: absolute;
	left: -55px;
	background-color: hsl(217, 88.2%, 90%);
	color: hsl(217, 88.8%, 35.1%);
	border-radius: 50%;
	height: 31px;
	width: 31px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.log-activity-item {
	background-color: #cccccc36;
	/* Warna abu */
	padding: 20px;
	/* Sesuaikan dengan kebutuhan Anda */
	border-radius: 10px;
	/* Border radius yang sesuai */
}

.changes-style {
	background-color: #00c73917;
	color: green;
	padding: 0.5rem;
}

.changes-style-current {
	background-color: #c7000017;
	color: red;
	padding: 0.5rem;
}

.body-log-modal {
	max-height: 33rem;
	overflow-y: auto;
}

.row {
	display: flex;
}

.col-md-6 {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.user-select-none {
	cursor: default !important;
}

table {
	table-layout: fixed;
}

.overflow-auto {
	overflow: auto;
}

.word-break {
	word-break: break-all;
}
</style>
